import React, { useState, useContext } from 'react';
import { UserContext } from '../app/app';
import GiftShow from 'gift/gift-show';
import GiftEdit from 'gift-edit/gift-edit';
import { deleteData } from '../firebase';
import './gift.scss';

const Gift = ({ email, gift, uuid, userId }) => {
  const { currentUser } = useContext(UserContext);
  const [mode, setMode] = useState('show');

  const deleteGift = () => {
    deleteData(`/users/${uuid}/gifts/${gift.uuid}`);
  };

  const renderDragButton = () => {
    if (userId !== currentUser.uid) return null;

    return (
      <button className="button button-drag" title="Drag &amp; Drop">
        <span className="button-text">Drag &amp; Drop</span>
      </button>
    );
  };

  const controls = () => {
    if (mode === 'show' && email === currentUser.email) {
      return (
        <div className="gift-controls">
          {renderDragButton()}
          <div className="gift-editButtons">
            <button
              className="button button-edit"
              title="Edit"
              onClick={() => setMode('edit')}
            >
              <span className="button-text">Edit</span>
            </button>
            <button
              className="button button-delete"
              title="Delete"
              onClick={deleteGift}
            >
              <span className="button-text">Delete</span>
            </button>
          </div>
        </div>
      );
    }
  };

  const renderMode = () => {
    if (mode === 'edit') {
      return (
        <GiftEdit close={() => setMode('show')} userId={userId} {...gift} />
      );
    } else {
      return <GiftShow email={email} gift={gift} userId={userId} uuid={uuid} />;
    }
  };

  return (
    <li className="gift" data-uuid={gift.uuid}>
      {controls()}
      {renderMode()}
    </li>
  );
};

export default Gift;
